import { Stack, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { TextWithSubtextSkeleton } from '../../../../../AssetsLoading';
import { FixedIncomeSharedInfoTypes, FixedIncomeSharedInfoTypesLoading } from '../types';

export const ApplicationInfo: React.FC<FixedIncomeSharedInfoTypes> = ({
  selectedFee,
  offer,
  w,
}) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Aplicação</Text>
        <Text>Max: {Utils.Mask.Money(selectedFee?.max || offer.applicationMaximumAmount)}</Text>
        <Text color="neutral.dark" fontSize="xs">
          Min: {Utils.Mask.Money(selectedFee?.min || offer.applicationIncreaseAmount)}
        </Text>
      </VStack>
    </Stack>
  );
};

export const ApplicationInfoLoading: React.FC<FixedIncomeSharedInfoTypesLoading> = ({ w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Aplicação</Text>
        <TextWithSubtextSkeleton />
      </VStack>
    </Stack>
  );
};
